import React, { useState, useEffect, useRef, useCallback } from 'react';
import BeneficiaryAudioGramUI from './BeneficiaryAudioGramUI';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AudiosGramData } from '../../../utils/helper';
import { fetchOscillaDetails, fetchOscillaTestStartedDetails } from '../../../store/actions/OscillaDataAction';
import { callApiAction } from '../../../store/actions/commonAction';
import { getBeneficiaryByIdApi, updateBeneficiaryApi } from '../../../apis/beneficiary.api';
import { callSnackBar } from '../../../store/actions/snackbarAction';
import { SNACK_BAR_VARIETNS } from '../../../utils/constants';
import { CreatePatientApi } from '../../../apis/patient.api';
import MessageDilog from '../../../components/MessageDilog';
import { closeModal, openModal } from '../../../store/actions/modalAction';
import { LoadingAction } from '../../../store/actions/loading.Action';

const BeneficiaryAudioGramController = () => {
    const { state } = useLocation();
    const { testStarted, data, test_data } = useSelector((state) => state.oscilla);
    const [loading, setLoading] = useState(false);
    const [loadingModal, SetloadingModal] = useState(false)

    const dispatch = useDispatch();
    const [fields, setFields] = useState(state?.patientData || { suggestedProduct: [], device: null });
    const [step, setStep] = useState(0);
    const [originalDocument, setOriginalDocument] = useState({});
    const navigate = useNavigate()

    const updateFunction = async () => {
        let updatedData = { id: fields?._id };

        for (let field in fields) {
            if (fields[field] != originalDocument[field]) {
                const fieldVal = fields[field];
                updatedData[field] =
                    fieldVal && typeof fieldVal == "object" ? fieldVal["_id"] : fieldVal;
            }
            if (!originalDocument[field]) {
                const fieldVal = fields[field];
                updatedData[field] =
                    fieldVal && typeof fieldVal == "object" ? fieldVal["_id"] : fieldVal;
            }
        }

        setLoading(true);
        dispatch(
            callApiAction(
                async () => await updateBeneficiaryApi({
                    ...fields,
                    // ...updatedData,
                    id: fields?._id,
                    device: fields?.device,
                    suggestedProduct: fields?.suggestedProduct,
                    has_hearing_loss: fields?.has_hearing_loss,
                    camp: fields?.cmp?._id ? fields?.cmp?._id : fields?.cmp,
                    islms: true
                }),
                async (response) => {
                    setLoading(false);
                    dispatch(
                        callSnackBar(
                            "Data updated successfully",
                            SNACK_BAR_VARIETNS.suceess
                        )
                    );
                    navigate("/beneficiary/beneficiary-data")
                },
                (err) => {
                    setLoading(false);
                    setFields({ ...fields, err });
                }
            )
        );
    };

    const fetchById = (id) => {
        // setFetchLoading(true);
        dispatch(
            callApiAction(
                async () => await getBeneficiaryByIdApi({ id }),
                async (response) => {
                    setFields({ ...fields, ...response });
                    setOriginalDocument(response);
                },
                (err) => {
                    setFields({ ...fields, err });
                }
            )
        );
    };

    useEffect(() => {
        if (state?.patientData?._id) fetchById(state?.patientData?._id);
    }, [state?.patientData?._id]);

    useEffect(() => {
        if (state?.patientData?._id) {
            dispatch(fetchOscillaDetails(state?.patientData?._id));
        }
    }, [state?.patientData?._id]);

    const oscillaTestStarted = JSON.stringify(data) !== JSON.stringify(test_data)

    useEffect(() => {
        if (oscillaTestStarted && testStarted) {
            dispatch(fetchOscillaDetails(state?.patientData?._id));
            fetchById(state?.patientData?._id);
        }
    }, [oscillaTestStarted]);
    useEffect(() => {
        let interval;
        if (testStarted) {
            interval = setInterval(() => {
                dispatch(fetchOscillaTestStartedDetails(state?.patientData?._id));
            }, 6000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [testStarted]);

    const [oscillaAudiogramState, setOscillaAudiogramState] = useState({ allowed_Oscilla: false });

    useEffect(() => { setOscillaAudiogramState({ allowed_Oscilla: AudiosGramData(data)?.length > 0 ? true : false, ...data }); }, [data]);


    const CreatepatientWeConfig = () => {
        dispatch(LoadingAction(true))
        dispatch(
            callApiAction(
                async () => await CreatePatientApi({ ...fields, zip_code:fields?.PIN}),
                async (response) => {
                    dispatch(LoadingAction(false))
                    dispatch(closeModal('Validate'));
                    dispatch(
                        callSnackBar(
                            "Create successfully",
                            SNACK_BAR_VARIETNS.suceess
                        )
                    );
                },
                (err) => {
                    dispatch(LoadingAction(false))
                    dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.warning));
                }
            )
        );
    }

    const onValidate = () => {
        dispatch(openModal(
            <MessageDilog
            id={"Validate"}
            title="Patient Creation Confirmation"
            message={"You are about to create a new patient record for WeConfig Development. Do you wish to proceed?"}
            // message={"This action will create a new patient record for WeConfig Development. Please confirm to continue."}
            confirmText="Validate"
            onSubmit={(e) => {
                e.preventDefault()
                CreatepatientWeConfig()
            }}
        />, "xs", false,"Validate"))
    }

    return (
        <BeneficiaryAudioGramUI
            _id={state?.patientData?._id}
            onValidate={onValidate}
            fields={fields}
            setFields={setFields}
            setOscillaAudiogramState={setOscillaAudiogramState}
            oscillaAudiogramState={oscillaAudiogramState}
            loading={testStarted || loading}
            fetchById={fetchById}
            step={step}
            setStep={setStep}
            updateFunction={updateFunction}
        />
    );
};

export default BeneficiaryAudioGramController;